module.exports = __webpack_public_path__ + "static/media/cssda-nominee-purple-vote.decf69e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/header/assets/cssda-nominee-purple-vote.png
// module id = 50
// module chunks = 0